import React from "react";
import { motion } from "framer-motion";
import * as Icons from "lucide-react";

export const ServiceCard = ({ icon, title, desc, index = 0, accent = "sage" }) => {
  const Icon = Icons[icon] || Icons.Stethoscope;
  const accentClass = accent === "gold" ? "text-brand-goldDark" : "text-brand-tealDark";
  return (
    <motion.div
      initial={{ opacity: 0, y: 16 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.5, delay: (index % 8) * 0.04 }}
      className="bg-paper p-9 md:p-10 transition-colors duration-300 hover:bg-paper-soft group"
      data-testid={`service-card-${title.toLowerCase().replace(/\s+/g, "-")}`}
    >
      <Icon className={`w-7 h-7 ${accentClass} mb-7`} strokeWidth={1.3} />
      <h3 className="heading-serif text-2xl md:text-[26px] font-medium text-brand-navyDark mb-3 tracking-tight">
        {title}
      </h3>
      <p className="text-[14.5px] text-brand-body leading-[1.8]">{desc}</p>
    </motion.div>
  );
};
